import React from "react"
import ActivationCard from "./ActivationCard"

const Activate = () => {
  return <ActivationCard />
}

export default Activate
